module.exports = __webpack_public_path__ + "img/authOne.af076563.png";